import React from 'react';
import { Reveal } from './Reveal';
const traits = [{
  title: 'Tienes metas',
  text: 'Y quieres seguir avanzando.'
}, {
  title: 'Quieres aprender',
  text: 'Estás abierto/a a desarrollar nuevas habilidades.'
}, {
  title: 'Valoras tu flexibilidad',
  text: 'Buscas algo que puedas desarrollar a tu ritmo.'
}, {
  title: 'Trabajas por resultados',
  text: 'Entiendes que crecer también requiere compromiso.'
}];
export function Profile() {
  return <section id="perfil" className="w-full scroll-mt-16 bg-ivory py-24 sm:py-32 lg:py-44" aria-labelledby="profile-title" data-id="element-176" data-mp="2k7ggfnvfziii">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-177" data-mp="2p618h00jivvv">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-24" data-id="element-178" data-mp="2ty1e993akj0d">
          <div data-id="element-179" data-mp="1wix7r78hd3pw">
            <Reveal data-id="element-180" data-mp="1wh3wtfqu3xc3">
              <p className="font-sans text-[10px] font-medium uppercase tracking-widest2 text-champagne sm:text-[11px]" data-id="element-181" data-mp="1whvkm4e6wqrt">
                ¿Te identificas?
              </p>
              <h2 id="profile-title" className="mt-8 font-sans text-[1.85rem] font-light uppercase leading-[1.12] text-ink sm:text-[2.5rem]" data-id="element-182" data-mp="3jj45larapiqq">
                Esto podría ser para ti
                <br className="hidden sm:block" data-id="element-183" data-mp="39sjb9zinn0dm" /> si quieres algo más de ti
                mismo/a.
              </h2>
            </Reveal>

            <dl className="mt-14 grid grid-cols-1 gap-x-14 border-t border-ink/12 sm:grid-cols-2" data-id="element-184" data-mp="30tedwwitxd31">
              {traits.map((trait, i) => <Reveal key={trait.title} delay={Math.min(i * 0.07, 0.25)} className="border-b border-ink/12" data-id="element-185" data-mp="2vt01z3e3xizq" data-mpi={i}>
                  <div className="py-8" data-id="element-186" data-mp="2muy4uyxhvahq">
                    <dt className="font-sans text-sm font-medium uppercase tracking-[0.2em] text-ink" data-id="element-187" data-mp="2mvzer02rxqxv">
                      {trait.title}
                    </dt>
                    <dd className="mt-3 max-w-xs font-sans text-base font-light leading-relaxed text-steel" data-id="element-188" data-mp="l3usa441nluj">
                      {trait.text}
                    </dd>
                  </div>
                </Reveal>)}
            </dl>
          </div>

          <Reveal delay={0.1} data-id="element-189" data-mp="25ku5bq8mfs1y">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/e85dfb04-dd2d-4dab-874a-4568bb912bb3.jpg" alt="Profesional mirando por la ventana de una oficina moderna con luz natural" className="h-[380px] w-full object-cover sm:h-[540px] lg:h-[660px]" data-id="element-190" data-mp="25lvjw4ouiwof" />
          </Reveal>
        </div>

        <Reveal delay={0.12} data-id="element-191" data-mp="2ob24jx979ycv">
          <div className="mt-20 max-w-3xl sm:mt-24" data-id="element-192" data-mp="2oa0jczygzvhf">
            <p className="font-sans text-2xl font-light uppercase leading-tight tracking-[0.02em] text-ink sm:text-4xl" data-id="element-193" data-mp="2odek63rhjwmr">
              No necesitas experiencia.
            </p>
            <p className="mt-3 font-serif text-2xl italic leading-snug text-champagne sm:text-[2.1rem]" data-id="element-194" data-mp="1culoq2tqhfph">
              Necesitas disposición para aprender, crecer y tomar acción.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}